"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHighlightTextRanges = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _utils = require("../utils");
const useHighlightTextRanges = highlightTextProps => {
  const {
    searchTerm,
    children: text
  } = highlightTextProps;
  if (!searchTerm || !text) {
    return [];
  }
  const searchTerms = (0, _checkoutUtils.getDistinctValues)(searchTerm.split(' '));
  const indexRanges = (0, _utils.getSubstringIndexRanges)(searchTerms, text);
  const mergedIndexRanges = (0, _utils.getMergedIndexRanges)(indexRanges);
  return (0, _utils.getSplittedTextByIndexRanges)(text, mergedIndexRanges);
};
exports.useHighlightTextRanges = useHighlightTextRanges;